<template>
    <div class="container tw-flex tw-flex-col tw-items-center busy">
      <title-section
      title="¿Esta ocupado?"></title-section>
      <div class="mdc-chip-set mdc-chip-set--choice justify-center tw-mt-8 tw-flex tw-flex-col">
        <div class="tw-flex lg:tw-flex-row tw-flex-col">
          <div class="mdc-chip" :class="{'mdc-chip--selected': isSelected('vacio')}" @click="selectChip('vacio')" role="row">
            <div class="mdc-chip__ripple"></div>
            <span role="gridcell">
              <span role="button" tabindex="0" class="mdc-chip__primary-action">
                <span class="mdc-chip__text">Está vacío</span>
              </span>
            </span>
            <span role="gridcell">
              <i class="material-icons mdc-chip__icon" role="button">done</i>
            </span>
          </div>
          <div class="mdc-chip" :class="{'mdc-chip--selected': isSelected('alquilado')}" @click="selectChip('alquilado')" role="row">
            <div class="mdc-chip__ripple"></div>
            <span role="gridcell">
              <span role="button" tabindex="0" class="mdc-chip__primary-action">
                <span class="mdc-chip__text">Alquilado</span>
              </span>
            </span>
            <span role="gridcell">
              <i class="material-icons mdc-chip__icon" role="button">done</i>
            </span>
          </div> 
        </div>
        <div class="tw-flex lg:tw-flex-row tw-flex-col">
          <div class="mdc-chip" :class="{'mdc-chip--selected': isSelected('ocupador-por-mi')}" @click="selectChip('ocupador-por-mi')" role="row">
            <div class="mdc-chip__ripple"></div>
            <span role="gridcell">
              <span role="button" tabindex="0" class="mdc-chip__primary-action">
                <span class="mdc-chip__text">Ocupado por mi</span>
              </span>
            </span>
            <span role="gridcell">
              <i class="material-icons mdc-chip__icon" role="button">done</i>
            </span>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { initiateChips } from "../../utils";
  import { mapMutations, mapGetters } from "vuex";
  export default {
    computed: {
        ...mapGetters({
            wizard: 'getWizard'
        })
    },
    methods: {
      ...mapMutations(["selectOccupied"]),
      selectChip(chip) {
        this.selectOccupied(chip);
        this.$router.push({ name: "Features" });
      },
      isSelected(chip){
          return chip === this.wizard.occupied;
      }
    },
    mounted() {
      initiateChips();
    }
  };
  </script>
  
  <style lang="scss">
  @import "../../../sass/variables";
  .busy {
    .mdc-chip {
      width: 319.4px;
      height: 58.7px;
      @media(max-width: $lg){
        width: 100%;
      }
    }
  }
  </style>
  